export default {"src":"/_next/static/media/rads.dd273b42.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};